import React from 'react';

interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
    children?: any;
    onClick?: (e:any) => void;
    theme?: 'primary' | 'secondary' | 'danger' | 'dark' | 'light';
    disabled?: boolean;
    type?: 'button' | 'submit' | 'reset';
    size?: 'sm' | 'md' | 'lg';
    working?: boolean;
    className?: string;
}

const Button: React.FC<ButtonProps> = ({ children, type = 'button', onClick = ()=>{}, theme='primary',  disabled = false , size = 'md', working = false, className}) => {

    const getTheme = () => {
        switch (theme) {
            case 'primary': return 'bg-primary text-green-100';
            case 'secondary': return 'bg-secondary text-white'; 
            case 'danger': return 'bg-red-600 text-white text-white'; 
            case 'dark': return 'bg-slate-800 text-white text-white'; 
            case 'light': return 'bg-white text-black text-black border border-gray-300';
            default: return 'bg-primary hover:bg-primary-dark text-white';
        }
    }
    const getSise = () => {
        switch (size) {
            case 'sm': return 'text-[0.75rem] rounded-[0.25rem] px-[0.5rem] py-[0.4rem] font-normal';
            case 'lg': return 'text-sm rounded-md px-5 py-2 font-medium'; 
            default: return 'text-sm rounded-md px-5 py-2 font-medium'; // md
        }
    }

    return (
        
        <button onClick={onClick} disabled={disabled || working} type={type} className={`relative hover:bg-opacity-90 ${disabled?'cursor-default':'cursor-pointer'} ${getTheme()} ${getSise()} disabled:opacity-50 ${className} `}>
            <div className={`flex items-center gap-2 ${working?'opacity-0':''}`}>{children}</div>
            
            {working &&
                <div className=' absolute flex items-center justify-center w-full h-full left-0 top-0 '>
                    <svg aria-hidden="true" className="inline w-5 h-5 text-slate-200 animate-spin dark:text-slate-100 fill-amber-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                    </svg>
                </div>
            }
        </button>
    );
};

export default Button;